'use client'

import { useState } from 'react'
import { toast } from 'sonner'
import { BT } from './tokens'

type Variant = 'compact' | 'list'

interface ShareActionsProps {
    url: string
    title: string
    variant?: Variant
}

type Action = {
    key: 'telegram' | 'vk' | 'copy'
    label: string
    compactLabel: string
    onClick: (url: string, title: string) => void | Promise<void>
}

const ACTIONS: Action[] = [
    {
        key: 'telegram',
        label: 'Telegram',
        compactLabel: 'TG',
        onClick: (url, title) => {
            const href = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`
            window.open(href, '_blank', 'noopener,noreferrer,width=640,height=640')
        },
    },
    {
        key: 'vk',
        label: 'VK',
        compactLabel: 'VK',
        onClick: (url, title) => {
            const href = `https://vk.com/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`
            window.open(href, '_blank', 'noopener,noreferrer,width=720,height=540')
        },
    },
    {
        key: 'copy',
        label: 'Скопировать URL',
        compactLabel: '©',
        onClick: async (url) => {
            try {
                await navigator.clipboard.writeText(url)
                toast.success('Ссылка скопирована')
            } catch {
                toast.error('Не удалось скопировать ссылку')
            }
        },
    },
]

export function ShareActions({ url, title, variant = 'compact' }: ShareActionsProps) {
    const [fullUrl] = useState(() => {
        if (typeof window !== 'undefined') {
            try {
                return new URL(url, window.location.origin).toString()
            } catch {
                return url
            }
        }
        return url
    })

    if (variant === 'list') {
        return (
            <div className="flex flex-col gap-1.5">
                {ACTIONS.map((a) => (
                    <button
                        key={a.key}
                        type="button"
                        onClick={() => a.onClick(fullUrl, title)}
                        className="flex items-center justify-between px-3 py-2.5 text-[13px]"
                        style={{
                            border: `1px solid ${BT.rule}`,
                            borderRadius: 4,
                            color: BT.ink,
                            background: BT.paper,
                            cursor: 'pointer',
                            textAlign: 'left',
                        }}
                    >
                        {a.label}
                        <span style={{ color: BT.accent }}>→</span>
                    </button>
                ))}
            </div>
        )
    }

    return (
        <div className="flex gap-2">
            {ACTIONS.map((a) => (
                <button
                    key={a.key}
                    type="button"
                    title={a.label}
                    aria-label={a.label}
                    onClick={() => a.onClick(fullUrl, title)}
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: 4,
                        border: `1px solid ${BT.rule}`,
                        background: BT.paper,
                        color: BT.ink,
                        fontFamily: BT.fontMono,
                        fontSize: 11,
                        fontWeight: 700,
                        cursor: 'pointer',
                    }}
                >
                    {a.compactLabel}
                </button>
            ))}
        </div>
    )
}
